import React from 'react';
import { Schema } from '../../toolympus/hooks/useSchema';
import { NewItemProps } from '../../toolympus/api/useNewItem';
import { CaseRecord } from './useCaseRecordsList';
import { FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';

interface Props extends NewItemProps<Partial<CaseRecord>, CaseRecord> {
  schema: Schema;
  caseType?: "international" | "national";
}

export const CreateCaseRecordDialog = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      submitOnModEnter
      dialogTitle="New case"
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["title", { controlProps: { autoFocus: true }}],
            ["case_date"],
            props.caseType === "national"
              ? ["national_parties", {}]
              : ["countries", { autoComplete: true, multiSelectValueDisplay: "text" }],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />
      </FormGrid>}
    </SimpleDialog>
  );
}

